import { AggregationAction } from '@next-space/fe-api-idl';
import { appI18n } from '@flowus/common/i18n';

export interface Series {
  name: string;
  data: (number | '-' | string)[];
  stack?: string;
  xAxisValueToMap: Record<string, number | string>;
}

export const getCommonCalculateItems = (): Record<string, string> => ({
  [AggregationAction.COUNT_ALL]: appI18n.t('common.chart.count') as string,
  [AggregationAction.DEDUPLICATION]: appI18n.t('common.chart.deduplication') as string,
});

export const getNumberCalculateItems = (): Record<string, string> => ({
  ...getCommonCalculateItems(),
  [AggregationAction.SUM]: appI18n.t('common.chart.sum') as string,
  [AggregationAction.MAX]: appI18n.t('common.chart.max') as string,
  [AggregationAction.MIN]: appI18n.t('common.chart.min') as string,
  [AggregationAction.AVERAGE]: appI18n.t('common.chart.average') as string,
});

export const getAllCalculateItems = (): Record<string, string> => ({
  ...getCommonCalculateItems(),
  [AggregationAction.SUM]: appI18n.t('common.chart.sum') as string,
  [AggregationAction.MAX]: appI18n.t('common.chart.max') as string,
  [AggregationAction.MIN]: appI18n.t('common.chart.min') as string,
  [AggregationAction.AVERAGE]: appI18n.t('common.chart.average') as string,
  '': '',
});

export const isChartNumberAggregation = (aggregation?: AggregationAction) => {
  if (!aggregation) return false;
  return [
    AggregationAction.SUM,
    AggregationAction.MAX,
    AggregationAction.MIN,
    AggregationAction.AVERAGE,
  ].includes(aggregation);
};
